// eslint-disable-next-line no-unused-vars
import axiosInterceptor from './helpers/axios-helper';

import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import { Home, Profile } from 'pages';
import DashboardLayout from 'layouts/DashboardLayout';
import {
  AUTH,
  CART,
  DASHBOARD,
  PAYMENT_SUMMARY,
  PROFILE,
  SHIPPING_BILLING,
  THANK_YOU,
  SIGNIN,
  SIGNUP,
  GOOGLE_COMPLETE,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS,
  RESET_PASSWORD,
  ORDERS,
  EDIT_PROFILE,
} from 'routes/routes';
import { Auth } from 'pages/Auth/Auth';
import { ThankYou } from 'pages/ThankYou/ThankYou';
import { Cart } from 'pages/Cart/Cart';
import { ShippingBilling } from 'pages/ShippingBilling/ShippingBilling';
import { PaymentSummary } from 'pages/PaymentSummary/PaymentSummary';
import { useAppSelector } from 'app/hooks';
import { PrivacyPolicy } from 'pages/PrivacyPolicy/PrivacyPolicy';
import { TermsAndConditions } from 'pages/TermsAndConditions/TermsAndConditions';
import { GoogleComplete } from 'pages/Auth/GoogleComplete/GoogleComplete';
import { Password } from 'pages/Auth/ResetPassword/Password';
import { Orders } from 'pages/Orders/Orders';
import { EditProfile } from 'pages/EditProfile/EditProfile';

const ProtectedRoute = ({ children }) => {
  const user = useAppSelector((state) => state.authentication.user);

  const isAuthenticated = user; // Replace with actual auth logic
  return isAuthenticated ? children : <Navigate to={SIGNIN} />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />

        <Route
          path={DASHBOARD}
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* Nested Route inside Dashboard */}
          <Route path={PROFILE} element={<Profile />} />
          <Route path={CART} element={<Cart />} />
          <Route path={SHIPPING_BILLING} element={<ShippingBilling />} />
          <Route path={PAYMENT_SUMMARY} element={<PaymentSummary />} />
          <Route path={THANK_YOU} element={<ThankYou />} />

          <Route path={PROFILE} element={<Profile />}>
            <Route path={ORDERS} element={<Orders />} />
            <Route path={EDIT_PROFILE} element={<EditProfile />} />
          </Route>
          {/* */}
        </Route>

        <Route path={AUTH} element={<DashboardLayout />}>
          <Route path={SIGNIN} element={<Auth />} />
          <Route path={SIGNUP} element={<Auth />} />
        </Route>

        <Route path={'/'} element={<DashboardLayout />}>
          <Route path={GOOGLE_COMPLETE} element={<GoogleComplete />} />
          <Route path={RESET_PASSWORD} element={<Password />} />
        </Route>

        <Route path={PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={TERMS_AND_CONDITIONS} element={<TermsAndConditions />} />
      </Routes>
    </Router>
  );
}

export default App;
